import type { ComponentPropsWithRef } from "react";
import { forwardRef } from "react";
import { omit } from "lodash";
import { t } from "@/i18n-js/instance";
import { classNames } from "@/react/helpers/twMergeWithCN";
import { Button } from "@circle-react-uikit/Button";
import { useBlocksContext } from "../../contexts/BlocksContext";

export interface FormButtonBlockProps extends ComponentPropsWithRef<"div"> {
  backgroundColor: string;
  "data-preview-mode"?: boolean;
  label: string;
  textColor: string;
}

export const FormButtonBlock = forwardRef<HTMLDivElement, FormButtonBlockProps>(
  (
    {
      label = t("settings.forms.default_submit"),
      className,
      "data-preview-mode": isPreview,
      ...rest
    },
    ref,
  ) => {
    const elementProps = omit(rest, [
      "backgroundColor",
      "textColor",
      "blockPath",
    ]);
    const { useFormRenderingContext } = useBlocksContext();
    const { buttonBackgroundColor, buttonTextColor } =
      useFormRenderingContext();

    return (
      <div
        ref={ref}
        className={classNames("mt-4 pb-2", className)}
        {...elementProps}
      >
        <Button
          variant="circle"
          full
          large
          className="!h-auto !py-3"
          type={isPreview ? "button" : "submit"}
          style={{
            color: buttonTextColor,
            backgroundColor: buttonBackgroundColor,
            borderColor: buttonBackgroundColor,
          }}
        >
          {label}
        </Button>
      </div>
    );
  },
);

FormButtonBlock.displayName = "FormButtonBlock";
